import React from 'react'
import {polyglot} from '../../index'

function withPolyglot (WrappedComponent, componentKey) {
  return class extends React.Component {
    translate (key, isParentDifferent, parent = 'common', options) {
      if (isParentDifferent) {
        return polyglot.t(`${parent}.${key}`, options)
      }
      return polyglot.t(`${componentKey}.${key}`, options)
    }
    render () {
      return <WrappedComponent {...this.props} translate={this.translate} />
    }
  }
}

export default withPolyglot

// This function takes a component...
// function withSubscription(WrappedComponent, selectData) {
//   // ...and returns another component...
//   return class extends React.Component {
//     constructor(props) {
//       super(props);
//       this.handleChange = this.handleChange.bind(this);
//       this.state = {
//         data: selectData(DataSource, props)
//       };
//     }
//
//     componentDidMount() {
//       // ... that takes care of the subscription...
//       DataSource.addChangeListener(this.handleChange);
//     }
//
//     componentWillUnmount() {
//       DataSource.removeChangeListener(this.handleChange);
//     }
//
//     handleChange() {
//       this.setState({
//         data: selectData(DataSource, this.props)
//       });
//     }
//
//     render() {
//       // ... and renders the wrapped component with the fresh data!
//       // Notice that we pass through any additional props
//       return <WrappedComponent data={this.state.data} {...this.props} />;
//     }
//   };
// }
